
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule, NgForm } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AuthChangePasswordRequest } from "@models/auth.model";
import { AuthService } from "@services/auth/auth-service";
import { JapaneseLabels, ErrorTexts } from "@utils/japaneseLabels";




/**
 * BasicSetting component.
 * Handles the display and logic for the application's basic settings page.
 */
@Component({
  selector: 'app-basic-setting',
  imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule],
  templateUrl: './basic-setting.html',
  styleUrl: './basic-setting.scss'
})
export class BasicSetting {

  japaneseLabel = JapaneseLabels;
  errorTexts = ErrorTexts;

  email_address !: string;
  token: string = localStorage.getItem('accessToken') ?? String();
  formData: AuthChangePasswordRequest = {
    access_token: this.token, // normally stored in local/session storage
    email_address: this.email_address,
    // eslint-disable-next-line no-restricted-syntax
    old_password: '',
    // eslint-disable-next-line no-restricted-syntax
    new_password: ''
  };
  confirmPassword !: string // For confirming new password;
  isSubmitting: boolean = false; // To prevent multiple submissions
  constructor(private authenticateService: AuthService) { }

  /**
   * Angular lifecycle hook.
   * Fetches the initial customer list on component initialization.
   */
  ngOnInit() {
    this.userInfo();
  }

  /**
   * Handle change-password form submission.
   *
   * - Validates the provided NgForm.
   * - Ensures the new password matches the confirmation field.
   * - Prevents duplicate submissions while a request is in flight.
   * - Calls AuthService.changePasswordApi with the form payload and handles result.
   *
   * @param form The Angular NgForm instance used for validation
   */
  onChangePassword(form: NgForm) {
    if (form.invalid) {
      return; // Angular will show errors
    }
    this.formData.email_address = this.email_address;
    console.log('Form Data:', this.formData);
    if (this.isSubmitting) {
      return; // Prevent multiple submissions
    }
    this.isSubmitting = true;
    // Call login API and observe full response to access headers
    this.authenticateService.changePasswordApi(this.formData).subscribe({
      next: (response) => {
        console.log('Password changed successfully:', response);
        this.isSubmitting = false;
        alert('パスワードを変更されました。');
        // this.router.navigate(['/dashboard']); // redirect
      },
      error: (error) => {
        console.error('Login Failed:', error);
        this.isSubmitting = false;
        alert('パスワードの変更に失敗しました。もう一度お試しください。');

      }
    });



  }


  /**
   * Load current user information from the API and populate component state.
   *
   * - Calls AuthService.getUserInfo with the stored token.
   * - On success sets this.email_address from the response.
   * - Logs errors to the console when the request fails.    
   */
  userInfo() {

    this.authenticateService.getUserInfo(this.token).subscribe({
      next: (response) => {
        console.log('User info fetched successfully:', response.email);
        this.email_address = response.email;
      },
      error: (error) => {
        console.error('Fetching user info failed:', error);

      }
    });
  }

}